__turbopack_export_value__({
  "body-logo-18": "serviceCard-module-scss-module__obajsG__body-logo-18",
  "body-text-12": "serviceCard-module-scss-module__obajsG__body-text-12",
  "body-text-14": "serviceCard-module-scss-module__obajsG__body-text-14",
  "body-text-16": "serviceCard-module-scss-module__obajsG__body-text-16",
  "body-text-18": "serviceCard-module-scss-module__obajsG__body-text-18",
  "body-text-20": "serviceCard-module-scss-module__obajsG__body-text-20",
  "body-text-24": "serviceCard-module-scss-module__obajsG__body-text-24",
  "body-text-24-2": "serviceCard-module-scss-module__obajsG__body-text-24-2",
  "body-text-heading-2": "serviceCard-module-scss-module__obajsG__body-text-heading-2",
  "body-text-heading-3": "serviceCard-module-scss-module__obajsG__body-text-heading-3",
  "body-text-medium-14": "serviceCard-module-scss-module__obajsG__body-text-medium-14",
  "body-text-medium-16": "serviceCard-module-scss-module__obajsG__body-text-medium-16",
  "body-text-medium-18": "serviceCard-module-scss-module__obajsG__body-text-medium-18",
  "body-text-medium2-18": "serviceCard-module-scss-module__obajsG__body-text-medium2-18",
  "body-text2-14": "serviceCard-module-scss-module__obajsG__body-text2-14",
  "body-text2-16": "serviceCard-module-scss-module__obajsG__body-text2-16",
  "button-primary-text": "serviceCard-module-scss-module__obajsG__button-primary-text",
  "button-text": "serviceCard-module-scss-module__obajsG__button-text",
  "button2-text": "serviceCard-module-scss-module__obajsG__button2-text",
  "card": "serviceCard-module-scss-module__obajsG__card",
  "card-shadow": "serviceCard-module-scss-module__obajsG__card-shadow",
  "card__icon": "serviceCard-module-scss-module__obajsG__card__icon",
  "card__inner": "serviceCard-module-scss-module__obajsG__card__inner",
  "card__title": "serviceCard-module-scss-module__obajsG__card__title",
  "effect-menu": "serviceCard-module-scss-module__obajsG__effect-menu",
  "header-1": "serviceCard-module-scss-module__obajsG__header-1",
  "main-container": "serviceCard-module-scss-module__obajsG__main-container",
  "main-footer-container": "serviceCard-module-scss-module__obajsG__main-footer-container",
  "main-header-container": "serviceCard-module-scss-module__obajsG__main-header-container",
  "txt-12-bold": "serviceCard-module-scss-module__obajsG__txt-12-bold",
  "txt-14-bold": "serviceCard-module-scss-module__obajsG__txt-14-bold",
  "txt-14-bold-caps": "serviceCard-module-scss-module__obajsG__txt-14-bold-caps",
  "txt-14-med": "serviceCard-module-scss-module__obajsG__txt-14-med",
  "txt-16-bold": "serviceCard-module-scss-module__obajsG__txt-16-bold",
  "txt-16-med": "serviceCard-module-scss-module__obajsG__txt-16-med",
  "txt-18-bold": "serviceCard-module-scss-module__obajsG__txt-18-bold",
  "txt-18-medium": "serviceCard-module-scss-module__obajsG__txt-18-medium",
  "txt-18-medium-24": "serviceCard-module-scss-module__obajsG__txt-18-medium-24",
  "txt-24-semi": "serviceCard-module-scss-module__obajsG__txt-24-semi",
});
